<template>
  <el-image-viewer v-bind="$attrs" @close="$emit('close')" />
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'PreviewImageViewer',
  inheritAttrs: false,
});
</script>
